import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function FaqBoard() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-4">
          <p className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
            <i className="ri-question-mark" aria-hidden="true"></i>
            常见问题
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于吃瓜的 FAQ
          </h2>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            从更新频率、合集区别到内容来源与纠错渠道，把大家常问的问题一次性说清楚。想了解怎么找瓜、怎么参与共建，都能在这里找到答案。
          </p>
          <a
            href="mailto:hello@haijiao.example"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            还有疑问？给我们写信
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={
                    "overflow-hidden rounded-2xl border transition-colors " +
                    (isOpen
                      ? "border-primary-200 bg-background-100"
                      : "border-background-200/70 bg-background-100/60 hover:border-background-300")
                  }
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-start gap-3">
                      <span
                        className={
                          "mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black " +
                          (isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700")
                        }
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="text-[15px] font-bold leading-snug text-foreground-900">
                        {f.q}
                      </span>
                    </span>
                    <i
                      className={
                        "ri-add-line text-xl text-foreground-500 transition-transform duration-300 " +
                        (isOpen ? "rotate-45 text-primary-600" : "")
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}